'use client';

import { useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';

interface SearchFormProps {
  searchQuery: string;
}

const SearchForm = ({ searchQuery }: SearchFormProps) => {
  const [inputValue, setInputValue] = useState(searchQuery);
  const router = useRouter();

  // Update the URL query when inputValue changes
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      // Only update the URL if inputValue has at least 3 characters and is different from searchQuery
      if (inputValue.length >= 3 && inputValue !== searchQuery) {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.set('name', inputValue);
        router.push(`?${queryParams.toString()}`, { scroll: false });
      }
      // If inputValue length is less than 3, remove the 'name' parameter from the URL
      else if (inputValue.length < 3 && searchQuery !== '') {
        const queryParams = new URLSearchParams(window.location.search);
        queryParams.delete('name'); // Remove 'name' query param
        router.push(`?${queryParams.toString()}`, { scroll: false });
      }
    }, 300); // 300 ms delay

    return () => clearTimeout(delayDebounceFn); // Cleanup timeout on unmount or change
  }, [inputValue, router, searchQuery]); // Include searchQuery as a dependency

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();

    // Redirect to the page with the search query in the URL
    if (inputValue.length >= 3) {
      router.push(`/?name=${inputValue}`, { scroll: false });
    }
  };

  return (
    <form
      onSubmit={handleSearch}
      className="mb-4  flex"
      dir="rtl"
    >
      <input
        type="text"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="نام محصول"
        className="border rounded-r p-2 text-black"
      />
      <button
        type="submit"
        className=" bg-green-500 text-white p-2 rounded-l"
      >
        جستجو
      </button>
    </form>
  );
};

export default SearchForm;
